import { render, staticRenderFns } from "./repayment-manage-handled.vue?vue&type=template&id=5c038fa4&scoped=true"
import script from "./repayment-manage-handled.vue?vue&type=script&lang=ts"
export * from "./repayment-manage-handled.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c038fa4",
  null
  
)

export default component.exports